export default __webpack_public_path__ + "static/media/vuesax-logo11.5a0e8e6a.svg";